// MasteryLevel — user self-assessed familiarity with course material.
//
// Decision (Session 19S · CONTENT_SPEC §M):
//   3 buckets driving ingest tone + content depth.
//   Default in form: 'partial' (middle ground for typical exam-prep user).
//
//   Meaning:
//     novice    — 0 background; AI generates textbook-grade lecture_notes,
//                 high-volume flashcards, recall/understand-heavy questions.
//     partial   — heard some lectures / partial notes; AI generates reference-
//                 book-style notes + understand/apply-heavy questions.
//     reviewed  — went through all material; AI generates outline + key facts
//                 (cheat-sheet style) + analyze/evaluate-heavy questions.
//
//   Future-extensible: z.enum 增值不破老（e.g. 'exam_eve' for last-24h cram）.
//
// Pairs with cognitiveLevel as orthogonal axis:
//   masteryLevel   = student input (what they bring)
//   cognitiveLevel = question output classification (Bloom)
import { z } from 'zod';
export const MasteryLevelSchema = z.enum([
    'novice', // 完全不会
    'partial', // 部分掌握（默认）
    'reviewed', // 听了所有课
]);
export const ALL_MASTERY_LEVELS = MasteryLevelSchema.options;
export const DEFAULT_MASTERY_LEVEL = 'partial';
//# sourceMappingURL=mastery-level.js.map